if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt, isFreeItemBasedTotal = false, formData = '') {
        evt.preventDefault();

        // NOTE: the delivery-date inputs are armed by handle-delivery-date.js
        // before submit (and re-armed on variant change) — the old
        // 'delivery-date:update' dispatch here could never win the race
        // against the synchronous FormData construction below.

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner') && this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        //let formData = '';
        if (formData === '' && isFreeItemBasedTotal == false) {
          //[Addition] if product has extra product along with it
          if (
            this.form.querySelector('input[name="gift_product"]') ||
            this.form.querySelector('input[name="personalization-id"]')
          ) {
            formData = new FormData();
            let items = this.setFormItemsGift();
            this.appendFormData(formData, 'items', items);
          } else {
            formData = new FormData(this.form);
          }
          //[Addition] if product has extra product along with it

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner') && this.querySelector('.loading__spinner').classList.add('hidden');

            if (
              window.enable_cart_free_item &&
              window.free_gift_productVID != null
            ) {
              //[Addition] CASE 3 for gift product, based on cart total add gift product to cart
              this.checkFreeItemBasedCartTotal(evt);
            }
          });
      }

      //[Addition] add gift product to form items to add to it cart once
      setFormItemsGift() {
        document
          .querySelector('personalization-drawer')
          ?.classList.remove('active');
        let quantity = document.querySelector(
          '.quantity__input[form="' + this.form.getAttribute('id') + '"]'
        )
          ? document.querySelector(
            '.quantity__input[form="' + this.form.getAttribute('id') + '"]'
          ).value
          : 1;
        let baseProductVID = this.form.id.value;
        let giftProductVID = this.form.querySelector(
          'input[name="gift_product"]'
        )?.value;
        let personalizationProductVID = this.form.querySelector(
          'input[name="personalization-id"]'
        )?.value;
        let uniqueId = Math.random().toString(16).slice(2);
        let text, color, font;
        if (personalizationProductVID) {
          text = document.querySelector('#personalize-text')?.value;
          color = document.querySelector('.selected-color')?.innerText;
          font = document.querySelector('.selected-font')?.innerText;
          uniqueId = baseProductVID + text + color + font;
        }
        let items = [];
        if (personalizationProductVID && giftProductVID) {
          items.push({
            id: personalizationProductVID,
            quantity: quantity,
            properties: {
              _unique_id: uniqueId,
              _is_personalization: true,
              Farbe: color,
              Schriftstil: font,
              Text: text,
            },
          });
          items.push({
            id: giftProductVID,
            quantity: quantity,
            properties: {
              _unique_id: uniqueId,
              _gift_product_relevantID: baseProductVID,
            },
          });
          items.push({
            id: baseProductVID,
            quantity: quantity,
            properties: {
              _has_personalization: true,
              _unique_id: uniqueId,
              Farbe: color,
              Schriftstil: font,
              Text: text,
            },
          });
        } else if (personalizationProductVID) {
          items.push({
            id: personalizationProductVID,
            quantity: quantity,
            properties: {
              _unique_id: uniqueId,
              _is_personalization: true,
              Farbe: color,
              Schriftstil: font,
              Text: text,
            },
          });
          items.push({
            id: baseProductVID,
            quantity: quantity,
            properties: {
              _has_personalization: true,
              _unique_id: uniqueId,
              Farbe: color,
              Schriftstil: font,
              Text: text,
            },
          });
        } else if (giftProductVID) {
          const pairUniqueId = baseProductVID + '_' + giftProductVID;
          items.push({
            id: giftProductVID,
            quantity: quantity,
            properties: {
              _unique_id: pairUniqueId,
              _gift_product_relevantID: baseProductVID,
            },
          });
          items.push({
            id: baseProductVID,
            quantity: quantity,
            properties: {
              _has_gift: true,
              _unique_id: pairUniqueId,
            },
          });
        }
        return items;
      }
      // setFormItemsPersonalization() {
      //   document.querySelector('personalization-drawer')?.classList.remove('active')
      //   let quantity = document.querySelector('.quantity__input[form="' + this.form.getAttribute('id') + '"]') ? document.querySelector('.quantity__input[form="' + this.form.getAttribute('id') + '"]').value : 1;
      //   let baseProductVID = this.form.id.value;

      //   let items = [];
      //   let personalizationProductVID = this.form.querySelector('input[name="personalization-id"]')?.value;
      //   console.log('doe', personalizationProductVID)
      //   if (personalizationProductVID) {
      //     items.push({
      //       "id": personalizationProductVID,
      //       "quantity": quantity,
      //       "properties": {
      //         "_personalization_product_relevantID": baseProductVID
      //       }
      //     })
      //   }
      //   items.push({
      //     "id": baseProductVID,
      //     "quantity": quantity,
      //     "properties": {
      //       "_has_personalization": true
      //     }
      //   })
      //   return items;
      // }

      appendFormData(formData, key, data) {
        if (data === Object(data) || Array.isArray(data)) {
          for (const i in data)
            this.appendFormData(formData, `${key}[${i}]`, data[i]);
        } else data && formData.append(key, data);
      }
      //[Addition] add gift product to form items to add to it cart once

      //[Addition] CASE 3 for gift product, based on cart total add gift product to cart
      checkFreeItemBasedCartTotal(evt) {
        let giftInCart = false;
        let cartContents = fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((data) => {
            if (parseFloat(window.free_gift_threshold) <= data.total_price) {
              for (let i = 0; i < data.items.length; i++) {
                if (
                  data.items[i].id === parseInt(window.free_gift_productVID)
                ) {
                  giftInCart = true;
                  break;
                }
              }
              if (!giftInCart) {
                let formData = new FormData();
                let items = [];
                items.push({
                  id: window.free_gift_productVID,
                  quantity: 1,
                  properties: {
                    _gift_based_cart_total: true,
                  },
                });
                this.appendFormData(formData, 'items', items);
                this.onSubmitHandler(evt, true, formData);
              }
            }
          });
      }
      //[Addition] CASE 3 for gift product, based on cart total add gift product to cart

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
